import MultipleChoice from "./KrMultipleChoice.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrMultipleChoice = install(MultipleChoice); // 生成带有 install 方法的组件

export default KrMultipleChoice;
